"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespaceEscape = exports.unescapeCSS = void 0;
const cssesc_1 = __importDefault(require("cssesc"));
function unescapeCSS(text) {
    return text.replace(/\\(.)/g, `$1`);
}
exports.unescapeCSS = unescapeCSS;
function namespaceEscape(name, namespace) {
    return namespace ? (0, cssesc_1.default)(namespace, { isIdentifier: true }) + `__` + name : name;
}
exports.namespaceEscape = namespaceEscape;
//# sourceMappingURL=escape.js.map